import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../Pages/Layout";
import PageNotFound from "../Pages/NotFound/404";
import SubscriptionList from "../Pages/CreateSubscription/SubscriptionList";
import CreateSubscription from "../Pages/CreateSubscription/CreateSubscription";
import Customers from "../Pages/Customers/Customers";
import Categories from "../Pages/Categories/Categories";
import Salons from "../Pages/Salons/Salons";
import Appoinments from "../Pages/Appoinments/Appoinments";
import CreateCategories from "../Pages/Categories/CreateCategories";
import CreateSalons from "../Pages/Salons/CreateSalons";
import { Login } from "../Pages/Login/Login";
import { ViewCustomers } from "../Pages/Customers/ViewCustomers";
import { ViewCategories } from "../Pages/Categories/ViewCategories";
import { ViewSalon } from "../Pages/Salons/ViewSalon";
import CreateService from "../Pages/Categories/CreateService";
import { Users } from "../Pages/UserManagement/Users/Users";

import { AddUser } from "../Pages/UserManagement/Users/AddUser";
import EditCategory from "../Pages/Categories/EditCategory";
import { ViewServices } from "../Pages/Categories/ViewServices";
import UpdateServices from "../Pages/Categories/UpdateServices";

import UserSteps from "../Pages/Salons/UserSteps";
import ViewAppointments from "../Pages/Appoinments/ViewAppointments";
// import {  UpdateUsers } from "../Pages/UserManagement/Users/UpdateUsers";
import AppSetting from "../Pages/App Setting/AppSetting";
import { BannerList } from "../Pages/App Setting/Dashboard/Image-Banner/BannerList";

import CustomServiceRequest from "../Pages/Dashboard/custom service request/CustomServiceRequest";

import { CustomRequestDetails } from "../Pages/Dashboard/custom service request/CustomRequestDetails";

import Video from "../Pages/App Setting/Dashboard/Video/Video";
import UpdateVideo from "../Pages/App Setting/Dashboard/Video/UpdateVideo";
import { CreateVideo } from "../Pages/App Setting/Dashboard/Video/CreateVideo";
import { Role } from "../Pages/UserManagement/Role/Role";
import { AddRole } from "../Pages/UserManagement/Role/AddRole";
import { EditRole } from "../Pages/UserManagement/Role/EditRole";
import { ViewRole } from "../Pages/UserManagement/Role/ViewRole";
import CommentRating from "../Pages/Comment-Ratings/CommentRating";
import CreateBanner from "../Pages/App Setting/Dashboard/Image-Banner/CreateBanner";
import UpdateBanner from "../Pages/App Setting/Dashboard/Image-Banner/UpdateBanner";
import { WebBannerList } from "../Pages/Website management/websiteBanners/WebBannerList";
import WebBannerCreate from "../Pages/Website management/websiteBanners/WebBannerCreate";
import WebBannerUpdate from "../Pages/Website management/websiteBanners/WebBannerUpdate";




import Dashboard from "../Pages/Dashboard/Dashboard";
import EditProfile from "../Pages/Customers/edit-customer-details/EditProfile";
import EditCustomerAddress from "../Pages/Customers/edit-customer-details/EditCustomerAddress";
import ViewAllNotification from "../Pages/ViewAllNotification";

import PrivateRoute from "../components/PrivateRoute";
import ProtectedRoute from "../components/ProtectedRoute";
import { UpdateUsers } from "../Pages/UserManagement/Users/UpdateUsers";
import CouponsList from "../Pages/Coupons/CouponsList";
import CreateCoupon from "../Pages/Coupons/CreateCoupon";
import EditCoupon from "../Pages/Coupons/EditCoupon";
import Setting from "../Pages/settings/Setting";
import { WebServiceList } from "../Pages/Website management/websiteServices/webServiceList";
import WebServiceCreate from "../Pages/Website management/websiteServices/webServiceCreate";
import WebServiceUpdate from "../Pages/Website management/websiteServices/webServiceUpdate";
import { WebTestimonialList } from "../Pages/Website management/websiteTestimonials/webTestimonialList";
import WebTestimonialCreate from "../Pages/Website management/websiteTestimonials/webTestimonialCreate";
import WebTestimonialUpdate from "../Pages/Website management/websiteTestimonials/webTestimonialUpdate";
import { WebAboutList } from "../Pages/Website management/aboutUs/webAboutList";
import WebAboutCreate from "../Pages/Website management/aboutUs/webAboutCreate";
import WebAboutUpdate from "../Pages/Website management/aboutUs/webAboutUpdate";
import { WebEnquiryList } from "../Pages/Website management/webEnquiry/webEnquiryList";
import { WebContactList } from "../Pages/Website management/contactDetails/webContactList";
import WebContactCreate from "../Pages/Website management/contactDetails/webContactCreate";
import WebContactUpdate from "../Pages/Website management/contactDetails/webContactUpdate";
const PageRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Login />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/dashboard/custom-service-request"
              element={<CustomServiceRequest />}
            />
            <Route
              path="/custom-service-request"
              element={<CustomServiceRequest />}
            />

            <Route
              path="/dashboard/custom-service-requet/view/:salonId"
              element={<CustomRequestDetails />}
            />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/edit/:id" element={<Customers />} />
            <Route
              path="/customers/details/:userId"
              element={<ViewCustomers />}
            />
            <Route path="/customers/sub" element={<SubscriptionList />} />
            <Route path="/customers/create" element={<CreateSubscription />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/add" element={<CreateCategories />} />
            <Route path="/categories/details" element={<ViewCategories />} />
            <Route path="/categories/edit/:id" element={<EditCategory />} />
            <Route path="/categories/view/:id" element={<ViewServices />} />

            <Route path="/categories/view-service" element={<ViewServices />} />
            <Route
              path="/categories/view-service/add/:categoryId"
              element={<CreateService />}
            />
            <Route
              path="/categories/view-service/update/:id"
              element={<UpdateServices />}
            />

            <Route path="/salons" element={<Salons />} />
            <Route path="/salons/add" element={<CreateSalons />} />
            <Route path="/salons/details/:salonId" element={<ViewSalon />} />

            <Route path="/salons/create-user" element={<UserSteps />} />
            <Route path="/appoinments" element={<Appoinments />} />
            <Route
              path="/appoinments/view/:id"
              element={<ViewAppointments />}
            />

            <Route path="/appoinments/view" element={<ViewAppointments />} />
            <Route path="/user-management/users" element={<Users />} />
            <Route path="/user-management/user/add" element={<AddUser />} />
            <Route
              path="/user-management/users/update/:staffId"
              element={<UpdateUsers />}
            />

            <Route path="/user-management/role" element={<Role />} />
            <Route path="/user-management/role/add" element={<AddRole />} />
            <Route
              path="/user-management/role/edit/:id"
              element={<EditRole />}
            />
            <Route path="/user-management/role/view" element={<ViewRole />} />

            <Route path="/comment-ratings" element={<CommentRating />} />
            <Route path="/app-setting" element={<AppSetting />} />
            <Route
              path="/app-setting/dashboard/banner/list"
              element={<BannerList />}
            />
            <Route
              path="/app-setting/dashboard/banner/create"
              element={<CreateBanner />}
            />
            <Route
              path="/app-setting/dashboard/banner/update/:id"
              element={<UpdateBanner />}
            />

            <Route path="/website-management/banner/list" element={<WebBannerList />} />
            <Route path="/website-management/banner/create" element={<WebBannerCreate />} />
            <Route path="/website-management/banner/update/:id" element={<WebBannerUpdate />} />

            <Route path="/website-management/services/list" element={<WebServiceList/>} />
            <Route path="/website-management/services/create" element={<WebServiceCreate/>} />
            <Route path="/website-management/services/update/:id" element={<WebServiceUpdate/>} />

            <Route path="/website-management/testimonials/list" element={<WebTestimonialList/>} />
            <Route path="/website-management/testimonials/create" element={<WebTestimonialCreate/>} />
            <Route path="/website-management/testimonials/update/:id" element={<WebTestimonialUpdate/>} />

            <Route path="/website-management/about/list" element={<WebAboutList/>} />
            <Route path="/website-management/about/create" element={<WebAboutCreate/>} />
            <Route path="/website-management/about/update/:id" element={<WebAboutUpdate/>} />

            <Route path="/website-management/contact/list" element={<WebContactList/>} />
            <Route path="/website-management/contact/create" element={<WebContactCreate/>} />
            <Route path="/website-management/contact/update/:id" element={<WebContactUpdate/>} />

            <Route path="/website-management/enquiry/list" element={<WebEnquiryList/>} />
       

            <Route path="/app-setting/dashboard/video" element={<Video />} />

            <Route
              path="/app-setting/dashboard/video/:id"
              element={<UpdateVideo />}
            />
            <Route
              path="/customers/view-details/profile/edit"
              element={<EditProfile />}
            />
            <Route path="/app-setting/dashboard/video/createVideo" element={<CreateVideo />} />
            <Route
              path="/customers/view-details/address/edit"
              element={<EditCustomerAddress />}
            />
            {/* <Route path="/dashboard/notifications" element={<ViewAllNotification/>}/> */}
            <Route
              path="/dashboard/notifications"
              element={<ViewAllNotification />}
            />
            <Route
              path="/settings" element={<Setting />}
            />

            <Route path="/coupons" element={<CouponsList />} />
            <Route path="/coupons/create" element={<CreateCoupon />} />
            <Route path="/coupon/edit/:id" element={<EditCoupon />} />
          </Route>
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
export default PageRoutes;
